import { PatternService } from "../../api/pattern-service";
import { EOSService } from "../../api/eos-service";

const state = {};

const getters = {};

const actions = {
    async GetPatternList() {
        return await EOSService.makeRequest(PatternService.GetPatternList())
    },
    async GetPatternCode(context, { GetPatternCodeParams }) {
        var params = new URLSearchParams()
        params.append('perno', GetPatternCodeParams.perno)
        params.append('section', GetPatternCodeParams.section)
        return await EOSService.makeRequest(PatternService.GetPatternCode(params))
    },
    async AddPattern(context, { name }) {
        var params = new URLSearchParams()
        params.append('name', name)
        return await EOSService.makeRequest(PatternService.AddPattern(params))
    },
    async DeletePattern(context, { patternId }) {
        var params = new URLSearchParams()
        params.append('patternId', patternId)
        return await EOSService.makeRequest(PatternService.DeletePattern(params))
    },
    async GetPatternPermission(context, { pid }) {
        var params = new URLSearchParams()
        params.append('id', pid)
        return await EOSService.makeRequest(PatternService.GetPatternPermission(params))
    },
    async UpdatePatternName(context, { payload }) {
        var data = new URLSearchParams()
        data.append('name', payload.name)
        data.append('id', payload.id)
        return await EOSService.makeRequest(PatternService.UpdatePatternName(data))
    },
    async UpdatePatternPermission(context, { payload }) {
        var data = new URLSearchParams()
        data.append('permission', payload.permission)
        data.append('id', payload.id)
        return await EOSService.makeRequest(PatternService.UpdatePatternPermission(data))
    },
    async findVacationPermission(context, { payload }) {
        var params = new URLSearchParams()
        params.append('patternid', payload.patternid)
        params.append('code', payload.code)
        return await EOSService.makeRequest(PatternService.findVacationPermission(params))
    },
    async findMissionPermission(context, { payload }) {
        var params = new URLSearchParams()
        params.append('patternid', payload.patternid)
        params.append('code', payload.code)
        return await EOSService.makeRequest(PatternService.findMissionPermission(params))
    },
    async findIOPermission(context, { payload }) {
        var params = new URLSearchParams()
        params.append('patternid', payload.patternid)
        return await EOSService.makeRequest(PatternService.findIOPermission(params))
    },
    async findExtraWorkPermission(context, { payload }) {
        var params = new URLSearchParams()
        params.append('patternid', payload.patternid)
        return await EOSService.makeRequest(PatternService.findExtraPermission(params))
    },
    async findSpecificExtraworkPermission(context, { payload }) {
        var params = new URLSearchParams()
        params.append('patternid', payload.patternid)
        return await EOSService.makeRequest(PatternService.findSpecificExtraworkPermission(params))
    },
    async DeletePatternDetailPermission(context, { DeletePatternDetailPermissionPayload }) {
        var params = new URLSearchParams()
        params.append('patternId', DeletePatternDetailPermissionPayload.patternId)
        params.append('code', DeletePatternDetailPermissionPayload.code)
        params.append('pageKind', DeletePatternDetailPermissionPayload.pageKind) // Vacation = 1, Mission = 2, IO = 3, ExtraWork = 4, EspecificExtraWork = 5
        return await EOSService.makeRequest(PatternService.DeletePatternDetailPermission(params))
    },
    async AddPatternDetailvacationPermission(context, { AddPatternDetailvacationPermissionPayload }) {
        var params = new URLSearchParams()
        params.append('patternid', AddPatternDetailvacationPermissionPayload.patternid)
        params.append('vacationCode', AddPatternDetailvacationPermissionPayload.vacationCode)
        params.append('statusCode', AddPatternDetailvacationPermissionPayload.statusCode)
        return await EOSService.makeRequest(PatternService.AddPatternDetailvacationPermission(params))
    },
    async AddPatternDetailMissionPermission(context, { AddPatternDetailMissionPermissionPayload }) {
        var params = new URLSearchParams()
        params.append('patternId', AddPatternDetailMissionPermissionPayload.patternId)
        params.append('missionCode', AddPatternDetailMissionPermissionPayload.missionCode)
        params.append('statusCode', AddPatternDetailMissionPermissionPayload.statusCode)
        return await EOSService.makeRequest(PatternService.AddPatternDetailMissionPermission(params))
    },
    async AddPatternDetailIoPermission(context, { AddPatternDetailIoPermissionPayload }) {
        var params = new URLSearchParams()
        params.append('patternId', AddPatternDetailIoPermissionPayload.patternId)
        params.append('statusCode', AddPatternDetailIoPermissionPayload.statusCode)
        return await EOSService.makeRequest(PatternService.AddPatternDetailIoPermission(params))
    },
    async AddPatternDetailExtraWorkPermission(context, { AddPatternDetailExtraWorkPermissionPayload }) {
        var params = new URLSearchParams()
        params.append('patternId', AddPatternDetailExtraWorkPermissionPayload.patternId)
        params.append('statusCode', AddPatternDetailExtraWorkPermissionPayload.statusCode)
        return await EOSService.makeRequest(PatternService.AddPatternDetailExtraWorkPermission(params))
    },
    async AddWebSectionDetailSpecificExtraWorkPermission(context, { AddSpecificExtraWorkPermissionPayload }) {
        var params = new URLSearchParams()
        params.append('patternId', AddSpecificExtraWorkPermissionPayload.patternId)
        params.append('statusCode', AddSpecificExtraWorkPermissionPayload.statusCode)
        return await EOSService.makeRequest(PatternService.AddWebSectionDetailSpecificExtraWorkPermission(params))
    },
    async DedicatePattern(context, { DedicatePatternParams }) {
        var params = new URLSearchParams()
        params.append('patternId', DedicatePatternParams.patternId)
        params.append('sectionid', DedicatePatternParams.sectionid)
        return await EOSService.makeRequest(PatternService.DedicatePattern(params))
    },
};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
}